import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { Lobby } from '@features/Remote/Lobby';
import { AppointmentParticipantType } from '@generated/gql/graphql';
import { useLoader } from '@hooks/useLoader';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { RequestState } from '@src/types/index';

import './styles.scss';

const RemoteLobby = () => {
  const {
    appointment,
    session,
    loading: appointmentLoading,
  } = useAppointmentContext();
  const navigate = useNavigate();
  const { setRequestState } = useLoader();
  useEffect(() => {
    setRequestState(
      appointmentLoading ? RequestState.loading : RequestState.success
    );
  }, [setRequestState, appointmentLoading]);

  if (!appointment?.id && !appointmentLoading) {
    navigate(paths.partner);
    return null;
  }

  const subTitle =
    session.userType === AppointmentParticipantType.Customer
      ? 'Your partner will join the appointment in a moment.'
      : 'Keep this page open while waiting, and share appointment details if needed.';

  return (
    <Layout invertTitle title="Appointment lobby" subTitle={subTitle}>
      <div className="remote__LobbyPage">
        <div className="wrapper">
          <Lobby />
        </div>
      </div>
    </Layout>
  );
};

export { RemoteLobby };
